import React, { FC } from 'react';
import { OrgQueryKeys } from '../../../../../api/config';
import { useOrganizationQuery } from '../../../../../api/queries/use-organization-query';
import type { LocationGroup, OrganizationLocation, Stop } from '../../../../../types';
import { toSiteDisplayNameFromOrganizationLocation } from '../../../../../utils/data-mapping';
import { getSingleColorTagStyle } from '../../../utils/drafts-loads-utils';

interface DisplayStopLocationProps {
    stop: Stop;
}

export const DisplayStopLocation: FC<DisplayStopLocationProps> = (props) => {
    const { stop } = props;
    const { data: organizationLocations = [] } = useOrganizationQuery<OrganizationLocation[]>(OrgQueryKeys.locations);
    const { data: locationGroups = [] } = useOrganizationQuery<LocationGroup[]>(OrgQueryKeys.locationGroups);
    const organizationLocation = organizationLocations.find(x => x.id === stop.organizationLocationId);
    const stopLocationName = organizationLocation && toSiteDisplayNameFromOrganizationLocation(organizationLocation);
    const displayStyle = getSingleColorTagStyle(organizationLocation?.groupId || null, locationGroups);

    return organizationLocation &&
        <span title={stopLocationName} style={displayStyle}>{stopLocationName}</span>
};
